import { CounterPartys } from "./types";

const defaultState = {
    all: [],
    allById: {},
    entriesById: {},
    error: null,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CounterPartys.SET:
            const allCptys = action.result.cptys || [];
            return {
                ...state,
                all: [...allCptys],
                allById: allCptys.reduce(
                    (cptys, cpty) => ({
                        ...cptys,
                        [cpty.id]: cpty,
                    }),
                    {}
                ),
                entriesById: allCptys.reduce(
                    (cptys, cpty) => ({
                        ...cptys,
                        [cpty.id]: cpty.entries,
                    }),
                    {}
                ),
            };

        case CounterPartys.UPDATE:
            let allByIdCopy = { ...state.allById };
            const newCptys = action.result.newCptys || [];
            let entriesByIdCopy = { ...state.entriesById };

            newCptys.forEach((ele) => {
                allByIdCopy[ele.id] = ele;
                // Prepare traders list
                if (Array.isArray(ele.entries)) {
                    entriesByIdCopy[ele.id] = ele.entries;
                }
            });

            // rebuild all list
            const all = Object.keys(allByIdCopy).map((key) => allByIdCopy[key]);

            return {
                ...state,
                error: null,
                all: all,
                allById: allByIdCopy,
                entriesById: entriesByIdCopy,
            };

        case CounterPartys.ERROR:
            return {
                ...state,
                error: action.error,
            };

        default:
            return state;
    }
};
